<div class="row progress-sub-level">
  <div class="container">
    <div class="progress-line"></div>

    <ul>
      <li [class.active]="currentStep === 1" [class.complete]="currentStep > 1">
        <div class="circle">
          @if (currentStep == 1) {
            <span>1</span>
          }
          @if (currentStep > 1) {
            <i class="fa fa-check"></i>
          }
        </div>
      </li>
      <li [class.active]="currentStep === 2" [class.complete]="currentStep > 2">
        <div class="circle">
          @if (currentStep <= 2) {
            <span>2</span>
          }
          @if (currentStep > 2) {
            <i class="fa fa-check"></i>
          }
        </div>
      </li>
      <li [class.active]="currentStep === 3" [class.complete]="currentStep > 3">
        <div class="circle">
          @if (currentStep <= 3) {
            <span>3</span>
          }
          @if (currentStep > 3) {
            <i class="fa fa-check"></i>
          }
        </div>
      </li>
      <li [class.active]="currentStep === 4">
        <div class="circle">
          4
        </div>
      </li>
    </ul>
  </div>
</div>